import React from "react";
import './login.css';
import FormSubmit from "./loginJS";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export default function Login() {

  return (
    <div className="loginPage">
      <form id="loginformid" onSubmit={(e) => {
        e.preventDefault();
        FormSubmit(e)
      }}>
        <img width="130px" className='loginImage' src="https://assets.ajio.com/static/img/Ajio-Logo.svg" alt="" />
        <h5 className="loginName">Welcome To Ajio</h5>
        <label className="formLabel">User Name</label>
        <input type="text" className="loginFormInput" name="nameInput" required />
        <label className="formLabel">Mail</label>
        <input type="email" className="loginFormInput" name='mailInput' required />
        <label className="formLabel">Password</label>
        <input type="password" className="loginFormInput" name='passwordInput' required />
        <button type="submit" className="loginButton">Sign In</button>
        <p className="loginAgree">By Signing In, I agree to Terms and Conditions.</p>
      </form>
      {/* <p className="loginAgree">Have an account already? <span className="signInbutton" onClick={()=>{
          setSignin(!signin)
        }}> Sign up </span> </p> */}
         <ToastContainer />
    </div>
  )
}

/*
   const [signin, setSignin] = useState(true);
   { signin ? 
   
   <div></div>
   :
     <div>
      <div className="signUp">
        <h5 className="loginName">Welcome To Ajio</h5>
        <form>
        <label className="formLabel">Your Name</label>
        <input type="text" className="loginFormInput" required/>
        <label className="formLabel">Password</label>
        <input type="password" className="loginFormInput" required />
        <button type="submit" className=" loginButton">Sign Up</button>
        </form>
        <p className="loginAgree">By Signing Up, I agree to Terms and Conditions.</p>
        <p className="loginAgree"> Create your new ajio account <span className="signInbutton" onClick={()=>{
          setSignin(!signin)
        }}> Sign in </span> </p>
    </div>
     </div>
      }

*/